import React, { FC } from 'react'
import { hot } from 'react-hot-loader/root'
import {
  Route,
  useRouteMatch,
  Switch,
} from 'react-router-dom'

import { URL } from './constants/url'
import Error from './pages/Error'
import Dashboard from './pages/dashboard/Index'
import Report from './pages/report/Index'
import ReportDetailMonthly from './pages/report/detail/monthly/Index'
import ReportDetailWeekly from './pages/report/detail/weekly/Index'
import DataSummary from './pages/dataSummary/Index'
import Analyze from './pages/analyze/Index'
import AppAnalyze from './pages/analyze/analyze_application/Index'
import AppAnalyzeDetail from './pages/analyze/analyze_application/Detail'
import AnalyzeReport from './pages/analyze/analyze_report/Index'
import AnalyzeReportDetail from './pages/analyze/analyze_report/Detail'
import Export from './pages/export/Index'
import ExportCsvList from './pages/export/csv/Index'
import ExportDataList from './pages/export/data/Index'
import ExportCsvDownload from './pages/export/csv/Download'
import ExportDataDownload from './pages/export/data/Download'
import SearchAll from './pages/search/search_all/Index'
import SettingProfile from './pages/setting/profile/Index'
import SettingMfaAuth from './pages/setting/mfaAuth/Index'
import SettingMember from './pages/setting/member/Index'
import SettingMemberDetail from './pages/setting/member/Detail'
import SettingTeam from './pages/setting/team/Index'
import SettingAdmin from './pages/setting/admin/Index'
import SettingIpRestriction from './pages/setting/ipRestriction'
import SettingOfficeIpAddress from './pages/setting/officeIpAddress'
import SettingImportCsv from './pages/setting/import/csv/Index'
import SettingClientDownload from './pages/setting/clientDownload/Index'
import SettingSlack from './pages/setting/slack/Index'
import SettingOauth from './pages/setting/oauth/Index'
import SettingMailDelivery from './pages/setting/mailDelivery/Index'
import SettingLanguage from './pages/setting/language/Index'
import SettingMeasurement from './pages/setting/measurement/Index'
import SettingWebBrowser from './pages/setting/webBrowser/Index'
import SettingMeasureRestriction from './pages/setting/measureRestriction/Index'
import SettingRecodeApiConnect from './pages/setting/recodeApiConnect/Index'
import SettingExternalApiKey from './pages/setting/externalApiKey/Index'
import SettingIndividualMeasurement from './pages/setting/individualMeasurement'
import SlackCallback from './pages/setting/SlackCallback'
import GoogleCallback from './pages/setting/GoogleCallback'
import MicrosoftCallback from './pages/setting/MicrosoftCallback'
import CybozuCallback from './pages/setting/CybozuCallback'
import FreeeCallback from './pages/setting/FreeeCallback'
import MasterTutorial from './pages/tutorial/MasterTutorial'
import MemberTutorial from './pages/tutorial/MemberTutorial'
import Task from './pages/task/Index'
import TaskDetail from './pages/task/task_detail/Index'
import TaskDetailDetail from './pages/task/task_detail/Detail'
import TaskCategoryDetail from './pages/task/task_category_detail/Index'
import TaskCategoryDetailDetail from './pages/task/task_category_detail/Detail'
import TaskLabelOrderSetting from './pages/task/task_label_order_setting'
import TaskLabelingStatus from './pages/task/task_labeling_status/Index'
import TaskLabelSetting from './pages/task/task_label_setting/Index'
import TaskLabelSettingDetail from './pages/task/task_label_setting/Detail'
import TaskTargetServiceSetting from './pages/task/task_target_service_setting/Index'
import TaskLabeling from './pages/task/task_labeling/Index'
import TaskAutoLabeling from './pages/task/task_auto_labeling/Index'
import TaskProjectCategory from './pages/task/task_project_category/Index'
import TaskMaster from './pages/task/task_master/Index'
import TaskCost from './pages/task/task_cost/Index'
import TaskPermission from './pages/task/task_permission/Index'
import TaskExcludeGenerateMemberSetting from './pages/task/task_exclude_generate_member_setting/Index'
import TaskProjectTemplateSetting from './pages/task/task_project_template_setting/Index'
import TaskProjectTemplateSettingDetail from './pages/task/task_project_template_setting/Detail'
import TaskApprovalSetting from './pages/task/task_approval_setting/Index'
import TaskApprovalStatus from './pages/task/task_approval_status/Index'
import TaskApprovalStatusDetail from './pages/task/task_approval_status/Detail'
import TaskCsvExport from './pages/task/task_csv_export/Index'
import TaskCsvExportDownload from './pages/task/task_csv_export/Download'
import TaskBulkLabeling from './pages/task/task_bulk_labeling/Index'
import TaskThresholdTimeSetting from './pages/task/task_threshold_time_setting/Index'
import TaskCreateManualTaskZoneSetting from './pages/task/task_create_manual_task_zone_setting/Index'
import TaskCreateTaskByUrlSetting from './pages/task/task_create_task_by_url_setting/Index'
import TaskLearningScopeSetting from './pages/task/task_learning_scope_setting/Index'
import TaskOnlineMeetingSetting from './pages/task/task_online_meeting_setting/Index'
import Risk from './pages/risk/Index'
import RiskTimeline from './pages/risk/timeline/Index'
import RiskMemberList from './pages/risk/member/Index'
import RiskMemberDetail from './pages/risk/member/Detail'
import RiskTeamList from './pages/risk/team/Index'
import RiskTeamDetail from './pages/risk/team/Detail'
import RiskCustomAlert from './pages/risk/customAlert/Index'
import GanttView from './pages/task/task_gantt_chart/Index'
import CustomAlert from './pages/customAlert/Index'
// import SettingHolidaySchedule from './pages/setting/holidaySchedule/Index'
import SettingContract from './pages/setting/contract/Index'
import SettingPersonal from './pages/setting/personal/Index'
import SettingCommon from './pages/setting/common/Index'
import SettingRole from './pages/setting/role/Index'
import SettingBaseWorkTime from './pages/setting/baseWorkTime/Index'
import SettingHoliday from './pages/setting/holiday/Index'

const LangRoute: FC = () => {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route path={path + URL.TUTORIAL_MASTER.path} component={MasterTutorial} />
      <Route path={path + URL.TUTORIAL_MEMBER.path} component={MemberTutorial} />
      <Route path={path + URL.REPORT_DETAIL_MONTHLY.path} component={ReportDetailMonthly} />
      <Route path={path + URL.REPORT_DETAIL_WEEKLY.path} component={ReportDetailWeekly} />
      <Route path={path + URL.DATA_SUMMARY.path} component={DataSummary} />
      <Route path={path + URL.REPORT_SEARCH.path} component={SearchAll} />
      <Route path={path + URL.TOP.path} component={Dashboard} />
      <Route path={path + URL.REPORT.path} component={Report} />
      <Route path={path + URL.ANALYZE_REPORT_DETAIL.path} component={AnalyzeReportDetail} />
      <Route path={path + URL.ANALYZE_REPORT.path} component={AnalyzeReport} />
      <Route path={path + URL.APP_ANALYZE_DETAIL.path} component={AppAnalyzeDetail} />
      <Route path={path + URL.APP_ANALYZE.path} component={AppAnalyze} />
      <Route path={path + URL.CSV_EXPORT.path} component={ExportCsvList} />
      <Route path={path + URL.DATA_SHEET_EXPORT.path} component={ExportDataList} />
      <Route path={path + URL.EXPORT.path} component={Export} />
      <Route path={path + URL.ANALYZE_SEARCH.path} component={SearchAll} />
      <Route path={path + URL.ANALYZE.path} component={Analyze} />
      <Route path={path + URL.SEARCH.path} component={SearchAll} />
      <Route path={path + URL.SETTING_MFA_AUTH.path} component={SettingMfaAuth} />
      <Route path={path + URL.SETTING_MEMBER_DETAIL.path} component={SettingMemberDetail} />
      <Route path={path + URL.SETTING_MEMBER.path} component={SettingMember} />
      <Route path={path + URL.SETTING_TEAM.path} component={SettingTeam} />
      <Route path={path + URL.SETTING_ADMIN.path} component={SettingAdmin} />
      <Route path={path + URL.SETTING_IMPORT_CSV.path} component={SettingImportCsv} />
      <Route path={path + URL.SETTING_CLIENT_DOWNLOAD.path} component={SettingClientDownload} />
      <Route path={path + URL.SETTING_SLACK.path} component={SettingSlack} />
      <Route path={path + URL.SETTING_OAUTH.path} component={SettingOauth} />
      <Route path={path + URL.SETTING_MAIL_DELIVERY.path} component={SettingMailDelivery} />
      <Route path={path + URL.SETTING_LANGUAGE.path} component={SettingLanguage} />
      <Route path={path + URL.SETTING_MEASUREMENT.path} component={SettingMeasurement} />
      <Route path={path + URL.SETTING_WEB_BROWSER.path} component={SettingWebBrowser} />
      <Route path={path + URL.SETTING_MEASUREMENT_RESTRICTION.path} component={SettingMeasureRestriction} />
      <Route path={path + URL.SETTING_RECODE_API_CONNECT.path} component={SettingRecodeApiConnect} />
      <Route path={path + URL.SETTING_IP_RESTRICTION.path} component={SettingIpRestriction} />
      <Route path={path + URL.SETTING_OFFICE_IP_ADDRESS.path} component={SettingOfficeIpAddress} />
      <Route path={path + URL.SETTING_PROFILE.path} component={SettingProfile} />
      <Route path={path + URL.SETTING_EXTERNAL_API_KEY.path} component={SettingExternalApiKey} />
      {/* <Route path={path + URL.SETTING_HOLIDAY_SCHEDULE.path} component={SettingHolidaySchedule} /> */}
      <Route path={path + URL.SETTING_HOLIDAY.path} component={SettingHoliday} />
      <Route path={path + URL.SETTING_BASE_WORK_TIME.path} component={SettingBaseWorkTime} />
      <Route path={path + URL.SETTING_INDIVIDUAL_MEASUREMENT.path} component={SettingIndividualMeasurement} />
      <Route path={path + URL.SETTING_CONTRACT.path} component={SettingContract} />
      <Route path={path + URL.SETTING_PERSONAL.path} component={SettingPersonal} />
      <Route path={path + URL.SETTING_COMMON.path} component={SettingCommon} />
      <Route path={path + URL.SETTING_ROLE.path} component={SettingRole} />
      <Route path={path + URL.SETTING_TASK_PERMISSION.path} component={TaskPermission} />
      <Route path={path + URL.SETTING_TASK_APPROVAL_SETTING.path} component={TaskApprovalSetting} />
      <Route path={path + URL.SETTING_TASK_EXCLUDE_GENERATE_MEMBER_SETTING.path} component={TaskExcludeGenerateMemberSetting} />
      <Route path={path + URL.SETTING_TASK_THRESHOLD_TIME_SETTING.path} component={TaskThresholdTimeSetting} />
      <Route path={path + URL.SETTING_TASK_CREATE_MANUAL_TASK_ZONE_SETTING.path} component={TaskCreateManualTaskZoneSetting} />
      <Route path={path + URL.SETTING_TASK_CREATE_TASK_BY_URL_SETTING.path} component={TaskCreateTaskByUrlSetting} />
      <Route path={path + URL.SETTING_TASK_LEARNING_SCOPE_SETTING.path} component={TaskLearningScopeSetting} />
      <Route path={path + URL.SETTING_TASK_ONLINE_MEETING_SETTING.path} component={TaskOnlineMeetingSetting} />
      <Route path={path + URL.SETTING_CUSTOM_ALERT.path} component={CustomAlert} />
      <Route path={path + URL.TASK_CSV_EXPORT.path} component={TaskCsvExport} />
      <Route path={path + URL.TASK_BULK_LABELING.path} component={TaskBulkLabeling} />
      <Route path={path + URL.TASK_APPROVAL_SETTING.path} component={TaskApprovalSetting} />
      <Route path={path + URL.TASK_APPROVAL_STATUS_DETAIL.path} component={TaskApprovalStatusDetail} />
      <Route path={path + URL.TASK_APPROVAL_STATUS.path} component={TaskApprovalStatus} />
      <Route path={path + URL.TASK_APPROVAL_SELF.path} component={TaskApprovalStatusDetail} />
      <Route path={path + URL.TASK_PROJECT_TEMPLATE_SETTING_CREATE.path} component={TaskProjectTemplateSettingDetail} />
      <Route path={path + URL.TASK_PROJECT_TEMPLATE_SETTING_DETAIL.path} component={TaskProjectTemplateSettingDetail} />
      <Route path={path + URL.TASK_PROJECT_TEMPLATE_SETTING.path} component={TaskProjectTemplateSetting} />
      <Route path={path + URL.TASK_PERMISSION.path} component={TaskPermission} />
      <Route path={path + URL.TASK_COST.path} component={TaskCost} />
      <Route path={path + URL.TASK_PROJECT_CATEGORY.path} component={TaskProjectCategory} />
      <Route path={path + URL.TASK_MASTER.path} component={TaskMaster} />
      <Route path={path + URL.TASK_AUTO_LABELING.path} component={TaskAutoLabeling} />
      <Route path={path + URL.TASK_LABELING.path} component={TaskLabeling} />
      <Route path={path + URL.TASK_LABELING_SELF.path} component={TaskLabeling} />
      <Route path={path + URL.TASK_DETAIL_DETAIL.path} component={TaskDetailDetail} />
      <Route path={path + URL.TASK_DETAIL.path} component={TaskDetail} />
      <Route path={path + URL.TASK_CATEGORY_DETAIL_DETAIL.path} component={TaskCategoryDetailDetail} />
      <Route path={path + URL.TASK_CATEGORY_DETAIL.path} component={TaskCategoryDetail} />
      <Route path={path + URL.TASK_LABEL_ORDER_SETTING.path} component={TaskLabelOrderSetting} />
      <Route path={path + URL.TASK_LABELING_STATUS.path} component={TaskLabelingStatus} />
      <Route path={path + URL.TASK_LABEL_SETTING_CREATE.path} component={TaskLabelSettingDetail} />
      <Route path={path + URL.TASK_LABEL_SETTING_DETAIL.path} component={TaskLabelSettingDetail} />
      <Route path={path + URL.TASK_LABEL_SETTING.path} component={TaskLabelSetting} />
      <Route path={path + URL.TASK_TARGET_SERVICE_SETTING.path} component={TaskTargetServiceSetting} />
      <Route path={path + URL.TASK_THRESHOLD_TIME_SETTING.path} component={TaskThresholdTimeSetting} />
      <Route path={path + URL.TASK_CREATE_MANUAL_TASK_ZONE_SETTING.path} component={TaskCreateManualTaskZoneSetting} />
      <Route path={path + URL.TASK_CREATE_TASK_BY_URL_SETTING.path} component={TaskCreateTaskByUrlSetting} />
      <Route path={path + URL.TASK_LEARNING_SCOPE_SETTING.path} component={TaskLearningScopeSetting} />
      <Route path={path + URL.GANTT_VIEW.path} component={GanttView} />
      <Route path={path + URL.TASK_SEARCH.path} component={SearchAll} />
      <Route path={path + URL.TASK.path} component={Task} />
      <Route path={path + URL.RISK_CUSTOM_ALERT.path} component={RiskCustomAlert} />
      <Route path={path + URL.RISK_TEAM_DETAIL.path} component={RiskTeamDetail} />
      <Route path={path + URL.RISK_TEAM_LIST.path} component={RiskTeamList} />
      <Route path={path + URL.RISK_MEMBER_DETAIL.path} component={RiskMemberDetail} />
      <Route path={path + URL.RISK_MEMBER_LIST.path} component={RiskMemberList} />
      <Route path={path + URL.RISK_TIMELINE.path} component={RiskTimeline} />
      <Route path={path + URL.RISK.path} component={Risk} />
      <Route path={path + URL.CUSTOM_ALERT.path} component={CustomAlert} />
      <Route path={URL.GOOGLE_CALLBACK.path} component={GoogleCallback} />
      <Route path={URL.MICROSOFT_CALLBACK.path} component={MicrosoftCallback} />
      <Route path={URL.CYBOZU_CALLBACK.path} component={CybozuCallback} />
      <Route path={URL.SLACK_CALLBACK.path} component={SlackCallback} />
      <Route path={URL.FREEE_CALLBACK.path} component={FreeeCallback} />
      <Route path={URL.CSV_DOWNLOAD.path} component={ExportCsvDownload} />
      <Route path={URL.DATA_SHEET_DOWNLOAD.path} component={ExportDataDownload} />
      <Route path={URL.TASK_CSV_DOWNLOAD.path} component={TaskCsvExportDownload} />
      <Route component={Error} />
    </Switch>
  )
}

export default hot(LangRoute)
